module.exports = __webpack_public_path__ + "img/image-three.a99756b3.jpg";